var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 12.1667C8.75768 12.1667 10.9994 9.925 10.9994 7.16667V0.5H8.91602V7.16667C8.91602 8.775 7.60768 10.0833 5.99935 10.0833C4.39102 10.0833 3.08268 8.775 3.08268 7.16667V0.5H0.999349V7.16667C0.999349 9.925 3.24102 12.1667 5.99935 12.1667ZM0.166016 13.8333V15.5H11.8327V13.8333H0.166016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.de158de5f69050320270670aa2906e39.svg";
export { ForwardRef as ReactComponent };